import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/users";
import Loading from "components/pages/loading";
import Row from "./row";

export default function AdminUsersList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (id) => {
    setRecords(records.filter((record) => record.id !== id));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.users));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="max-w-screen-lg mx-auto">
      <h1 className="text-center">Users</h1>
      <div className="text-right mb-1">
        <a className="btn btn-outline-black btn-sm" href="/admin/users/new">Invite User</a>
      </div>
      <div className="table-responsive">
        <table className="table text-center">
          <thead>
            <tr>
              <th>Admin</th>
              <th>Email</th>
              <th>Name</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <Row key={record.id} onDestroy={onDestroy} record={record} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
